// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var StopTradingReason;
(function (StopTradingReason) {
    StopTradingReason[StopTradingReason["NONE"] = 0] = "NONE";
    StopTradingReason[StopTradingReason["UNKNOWN"] = 1] = "UNKNOWN";
    StopTradingReason[StopTradingReason["MAX_LOSS"] = 2] = "MAX_LOSS";
    StopTradingReason[StopTradingReason["MAX_DAY_VOL"] = 3] = "MAX_DAY_VOL";
    StopTradingReason[StopTradingReason["WEEKLY_LOST_LIMIT"] = 4] = "WEEKLY_LOST_LIMIT";
    StopTradingReason[StopTradingReason["TRAILING_DRAWDOWN_LIMIT"] = 5] = "TRAILING_DRAWDOWN_LIMIT";
    StopTradingReason[StopTradingReason["MAX_UNREALIZED_LOSS"] = 6] = "MAX_UNREALIZED_LOSS";
    StopTradingReason[StopTradingReason["MAX_DAILY_PROFIT"] = 7] = "MAX_DAILY_PROFIT";
    StopTradingReason[StopTradingReason["MAX_ORDERS_COUNT_PER_DAY"] = 9] = "MAX_ORDERS_COUNT_PER_DAY";
    StopTradingReason[StopTradingReason["RELATIVE_DRAWDOWN_LEVEL"] = 11] = "RELATIVE_DRAWDOWN_LEVEL";
    StopTradingReason[StopTradingReason["EOD_TRAILING_DRAWDOWN"] = 14] = "EOD_TRAILING_DRAWDOWN";
    StopTradingReason[StopTradingReason["RELATIVE_DAILY_LOSS_LIMIT"] = 15] = "RELATIVE_DAILY_LOSS_LIMIT";
})(StopTradingReason || (StopTradingReason = {}));
